import "config/sentry/index";
import "swiper/css/bundle";
import "styles/styles.scss";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { logBuildInfo } from "utils/logBuildInfo";
import App from "views/App";
import Providers from "views/Providers";

logBuildInfo();

createRoot(document.getElementById("root")).render(
	<StrictMode>
		<Providers>
			<App />
		</Providers>
	</StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
